import { isUndefined } from "lodash";
export function elevateClass(amount) {
  if (isUndefined(amount) || amount <= 0 || amount > 4) return '';
  return "elevate--".concat(amount);
}